import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SideBar from "../common/sideBar";
import { postServerDataWithPath } from "../../../action/common_action";
import {
  axiosInstnace as Axios,
  calculateAmountAndTax,
} from "../../../util/util";
import { endPoints } from "../../../config";
import { history } from "../../../history/history";
import NoData from "../common/NoData";
import Pagination from "../common/Pagination";
import DatePicker from "react-datepicker";
import { addDays, addMonths } from "date-fns";
import moment from "moment";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import Dropdown from "react-dropdown";

const Index = (props) => {
  const [campaigns, handleCampaignList] = useState([]);
  const [user_email, handleUserEmail] = useState("");
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [packagetype, handlePackagetype] = useState(undefined);

  //vjvjj
  const [campaignstatustype, handleCampaignstatustype] = useState(undefined);
  const [rostatustype, handleRostatustype] = useState(undefined);

  const [razorpay, handleRazorpay] = useState(undefined);
  const searchRazorpay = useRef(undefined);

  const [station, handleStation] = useState(undefined);
  const [email, handleEmail] = useState(undefined);
  const [audio, handleAudio] = useState("");
  const [campaignId, handleCampaignId] = useState("");
  const [searchName, handleSearchName] = useState(undefined);
  const [searchId, handleSearchId] = useState(undefined);
  const [fileType, handleFileType] = useState(undefined);
  const [status, handleStatus] = useState(undefined);
  const [statusStages, handleStatusStages] = useState(undefined);
  const [enableSideBar, handleEnableSideBar] = useState("admin");
  //vj
  // const [searchStation, handleSearchStation] = useState(undefined);
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const [showExcelPopup, setShowHideExcelPopup] = useState(false);
  const [showUploadContract, setShowHideUploadContract] = useState(false);
  const campaignName = useRef(undefined);
  const userEmail = useRef(undefined);
  const searchStation = useRef(station);
  const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
  const [currentCampaign, handleCurrentCampaign] = useState(undefined);
  const [updateObj, handleUpdateObj] = useState(undefined);

  // const packagetype = useRef(undefined);

  useEffect(() => {
    getCampaignlist(0, undefined, undefined, "Pending", false);
  }, []);

  //Fetching the campaign list
  const getCampaignlist = async (skip, name, id, status, reset) => {
    var paramsConstrct;
    if (!reset) {
      paramsConstrct = {
        skip,
        email: adminInfo.email,
      };
    }
    handleSkip(skip);
    try {
      const data = await Axios.post(
        endPoints.getcampaignsofAuditAdmin,
        paramsConstrct
      );
      let result = data.data.data.auditcampaigns;
      if (result) {
        result = result.map((campaign) => {
          return calculateAmountAndTax(campaign);
        });
        handleCampaignList(result);
        handleSearchName(name);
        handleRazorpay(razorpay);
        handleSearchId(id);
        handleCount(data.data.data.count);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const callSearch = () => {
    getCampaignlist(0, undefined, undefined, "Pending", false);
  };

  const clearSearch = () => {
    window.location.reload(true);
    // this.userEmail.current.value = "";

    //   const campaignName = undefined;
    //   const userEmail = undefined;
    //   setStartDate(undefined);
    //   setEndDate(undefined);
    //   handleEmail(undefined);
    //   handleRazorpay(undefined);
    //   handleSearchName(undefined);
    //   handleStation(undefined)
    //   // handleCampaignList([]);
    //   handlePackagetype(undefined);
    //   handleCampaignstatustype(undefined);
    //   handleRostatustype(undefined);

    //   getCampaignlist(0, undefined, undefined, "Pending",true);
  };

  const options = ["one", "two", "three", "four"];

  //Return the table for campaign
  return (
    <div>
      <div className="dashboardContainer">
        <HeaderAdminpanel />
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>{" "}
          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Incentive Management |
                <span className="breadcrumb-active advertiser-breadcrumb">
                  Incentive List{" "}
                </span>{" "}
              </div>
            </div>
            <div
              className={
                campaigns.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th>S. No</th>
                    <th>Campaign Id</th>
                    <th> Campaign Name </th> <th> Campaign payment Date </th>{" "}
                    <th> Station </th> <th> Price </th> <th> Incentive </th>{" "}
                    <th> Incentive Amount </th>
                  </tr>
                </thead>{" "}
                <tbody>
                  {" "}
                  {campaigns.map((c, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{c._id}</td>
                      <td> {c.name} </td>{" "}
                      {c.bigFmAudio === "false" &&
                        c.paymentdates &&
                        c.paymentdates.payId && (
                          <td>
                            {moment(parseInt(c.paymentdates.payId)).format(
                              "DD MMM YYYY"
                            )}
                          </td>
                        )}
                      {c.bigFmAudio === "true" &&
                        c.paymentdates &&
                        c.paymentdates.payId_1 && (
                          <td>
                            {moment(parseInt(c.paymentdates.payId_1)).format(
                              "DD MMM YYYY"
                            )}
                          </td>
                        )}
                      {!c.paymentdates && (
                        <td>{moment(c.createdAt).format("DD MMM YYYY")}</td>
                      )}
                      <td> {c.station ? c.station : ""} </td>{" "}
                      <td>{c.amount - c.audioCost}</td>
                      <td>5</td>
                      <td>{((c.amount - c.audioCost) * 0.05).toFixed(2)}</td>
                    </tr>
                  ))}{" "}
                </tbody>{" "}
              </table>{" "}
              <div className="paginationTable" />{" "}
              {(skip > 0 || count > 10) && (
                <Pagination getAllData={getCampaignlist} totalRecords={count} />
              )}{" "}
            </div>{" "}
            {campaigns.length === 0 ? <NoData /> : null}{" "}
          </section>{" "}
        </div>{" "}
      </div>{" "}
      {/* {campaigns.length ===0 && (!searchName && !searchId)?
                      <NoData /> : null} */}{" "}
      {showExcelPopup && <ExcelPopup hideExcelPopup={showHideExcelPopup} />}
      {showUploadContract && (
        <UploadContract
          hideUploadContract={showHideUploadContract}
          campaignId={campaignId}
          fileType={fileType}
          status={status}
          statusStages={statusStages}
          uploadContact={uploadContact}
          updateObj={updateObj}
          campaign={currentCampaign}
          updateCampaign={props.updateCampaign}
        />
      )}{" "}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCampaign: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./web/components/admin/audit_management/index.js